exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".leaflet-cluster-anim .leaflet-marker-icon, .leaflet-cluster-anim .leaflet-marker-shadow {\n\ttransition: transform 0.3s ease-out, opacity 0.3s ease-in;\n}\n\n.leaflet-cluster-spider-leg {\n\t/* stroke-dashoffset (duration and function) should match with leaflet-marker-icon transform in order to track it exactly */\n\ttransition: stroke-dashoffset 0.3s ease-out, stroke-opacity 0.3s ease-in;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/~/css-loader?{"sourceMap":false,"importLoaders":1}!F:/node/angular/complejidadesFrontend/~/postcss-loader?{"ident":"postcss"}!F:/node/angular/complejidadesFrontend/~/leaflet.markercluster/dist/MarkerCluster.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../leaflet.markercluster/dist/MarkerCluster.css
// module chunks = 2